
import { i18nText } from '@/locales';

import { Component, Vue } from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import { mixins } from "vue-class-component";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import { AccountHistoryTableMix } from "@/UI/mixins/Clients/AccountHistoryTableMix";
import {Button, Table, Row, Select, FormModel, Modal, message, Input} from "ant-design-vue";
import moment from "moment";
import { CashboxStore } from "@/store/modules/Finance/Cashbox";
import { PaymentCreateFormData, FormRules } from "@/form/Clients/Account/PaymentCreate";
import { HandleScrollStorewithParam, SearchinStore } from "@/UI/Decorators/decorator";
import { WorkersStore } from "@/store/modules/Workers";
import { ClientsStore } from "@/store/modules/Clients";
import { ResponseDataType } from '@/form/form.types'
import { clientsAccountsHistoryStore } from "@/store/modules/ClientsAccountHistory";
import { ProxyGetData } from "../Helpers/getData";
import { getStudioId } from "@/UI/lib/state";

@Component({
    components: {
        PageTitle,
        BaseDataForm,
        "a-table": Table,
        "a-button": Button,
        "a-row": Row,
        "a-select": Select,
        "a-select-option": Select.Option,
        "a-form-model": FormModel,
        "a-form-model-item": FormModel.Item,
        "a-modal": Modal,
        "a-input": Input,
    },
    methods: { moment },
})

export default class ClientAccount extends mixins(
    AccountHistoryTableMix,
    ProxyGetData
) {
    showModal = false;
    modalTitle = i18nText("Пополнить счет");
    mode = 0;
    searchTimeOut: any;
    form = new PaymentCreateFormData();
    rules = FormRules;

    @SearchinStore
    hSearch(source: string, value: string, useStudio?: boolean, field?: string, filter?: any): void {}
    @HandleScrollStorewithParam
    hScroll(event: any, source: string, items?: string, useStudio?: boolean, filter?: any): void {}
    handleScroll(event: any): void {
        this.hScroll(event, "workers", "workers", false, {salon_id: ClientsStore.client?.salon_id || getStudioId(this)});
    }
    handleSearch(value: string): void {
        this.hSearch("workers", value, false, 'name', {name: value, salon_id: ClientsStore.client?.salon_id || getStudioId(this)});
    }

    async onSubmit(): Promise<void> {
        (this.$refs.createPaymentAccountForm as FormModel).validate(async (valid) => {
            if (valid) {
                try {
                    let response: ResponseDataType;
                    if (this.mode === 0) {
                        response = await ClientsStore.createPaymentAccount(this.form);
                    }
                    else {
                        response = await ClientsStore.refillPaymentAccount(this.form);
                    } 
                    if (response && response.status) {
                        message.success(response.response);
                        
                        this.showModal = false;
                    } else if(response && !response.status) {
                        message.error(response.response);
                    } else {
                        message.error(i18nText("Непредвиденная ошибка. Пожалуйста, свяжитесь с тех. поддержкой"));
                    }
                } catch (e) {
                    message.error(e.response?.data?.errors ? Object.values(e.response.data.errors).flat().join(' ') : e.response?.data?.message || e.message);
                } finally {
                    await this.sortedData('desc', {dataIndex: 'created_at'})
                }
            }
        });
    }

    prepareDate(): void {
        if (ClientsStore.client) this.form.salon_id = ClientsStore.client["salon_id"];
        this.form.client_id = Number(Vue.router.currentRoute.params["id"]);
    }

    donateAccount(): void {
        this.mode = 1;
        this.prepareDate();
        this.showModal = true;
    }

    createAccount(): void {
        this.mode = 0;
        this.prepareDate();
        this.showModal = true;
    }

    async searchCashboxes(val: any): Promise<void> {
        clearTimeout(this.searchTimeOut);
        this.searchTimeOut = setTimeout(async () => {
            await CashboxStore.fetchAll({ limit: this.AppPageParams.pageSize, filter: {name: val, salon_id: ClientsStore.client?.salon_id || getStudioId(this)} });
        }, 500);
    }

    get cashBoxes(): any { return CashboxStore.items?.data }
    get workers(): any { 
        const filteredWorkers = WorkersStore.workers?.data.filter(worker => {
            return worker.status.id !== 2
        })
        return filteredWorkers
     }
    get clientAccHistory(): any { return clientsAccountsHistoryStore.items?.data }
    get hasAccount(): boolean { return Boolean(clientsAccountsHistoryStore.items?.account); }
    get accountBalance(): number { return clientsAccountsHistoryStore.items?.account?.balance || 0; }

    async created(): Promise<void> {
        try {
            this.proxyFilter = {
                client_id: Vue.router.currentRoute.params.id,
                salon_id: ClientsStore.client?.salon_id || getStudioId(this)
            }
            await this.sortedData('desc', {dataIndex: 'created_at'})
            await this.fetchModules([
                {s: 'workers', p: {limit: -1, filter: {salon_id: ClientsStore.client?.salon_id || getStudioId(this)}}},
                {s: 'cashbox', p: {filter: {salon_id: ClientsStore.client?.salon_id || getStudioId(this)}}}
            ])
        } catch (e) {
            console.error(e);
        } finally {
            this.formReady = true
            this.disabled_sort = true
        }
    }
}
